import { render, staticRenderFns } from "./ProfileDocumentForm.vue?vue&type=template&id=03dd66f1&"
import script from "./ProfileDocumentForm.vue?vue&type=script&lang=js&"
export * from "./ProfileDocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDocumentForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports